import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgRulesDisableFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M4.86 6.44c.03.05.05.1.06.16l.06.35.6 3.34a.5.5 0 00.5.41h4.32a.5.5 0 01.49.62l-.07.3a4.72 4.72 0 11-6.95-5.19l.3-.17a.5.5 0 01.69.18zm1-5.69a2.2 2.2 0 01.89 4.2l.02.13h2.51c.38 0 .7.29.74.65l.01.1c0 .42-.34.75-.75.75h-2.2l.39 1.82h4.43c.32 0 .6.2.7.5l1.28 3.7 1.13-.38a.75.75 0 11.48 1.42l-1.84.62a.75.75 0 01-.95-.47l-1.34-3.9h-4.5a.75.75 0 01-.73-.59l-.9-4.25a2.2 2.2 0 01.63-4.3z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgRulesDisableFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgRulesDisableFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgRulesDisableFilled svgRef={ref} {...props} />
));
export default ForwardRef;
